import { forwardRef, useLayoutEffect } from 'react';
import Slider from 'react-slick';

type ReactSlick = Slider & {
  children: any;
  sliderRefCallback: (x?: any) => void;
  className: string;
};

export const ReactSlickCarousel = forwardRef(function Slick(
  props: Partial<ReactSlick>,
  ref: any
) {
  const { children, sliderRefCallback, ...restProps } = props;

  useLayoutEffect(() => {
    // Dynamically load slick-carousel CSS
    import('slick-carousel/slick/slick.css' as any);
    import('slick-carousel/slick/slick-theme.css' as any);
  }, []);

  return (
    <Slider ref={sliderRefCallback} {...restProps}>
      {children}
    </Slider>
  );
});
